import { render } from "./ReferencesFiles.vue?vue&type=template&id=5a2a9a3c"
import script from "./ReferencesFiles.vue?vue&type=script&lang=js"
export * from "./ReferencesFiles.vue?vue&type=script&lang=js"

import "./ReferencesFiles.vue?vue&type=style&index=0&id=5a2a9a3c&lang=css"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__